import type { ReactNode } from 'react';

type ApplyWrapperProps = {
  when: boolean;
  wrapper: (children: ReactNode) => ReactNode;
  children: ReactNode;
};

function ApplyWrapper({ when, wrapper, children }: ApplyWrapperProps) {
  return when ? wrapper(children) : <>{children}</>;
}

export { ApplyWrapper };
